import { isUndefined } from 'lodash';
import { ReferenceLine } from '@/version-types';
import { getReferenceLinesState } from '../states/reference-lines-state';

export class DataOperation {
    constructor(private id: string) {}

    get() {
        const id = this.id;
        const lines = getReferenceLinesState(id).referenceLines;
        const show = getReferenceLinesState(id).showReferenceLines;
        const lock = getReferenceLinesState(id).lockReferenceLines;
        return {
            lines,
            show,
            lock,
        };
    }

    set(data: { lines: ReferenceLine[]; show?: boolean; lock?: boolean }) {
        const id = this.id;
        const { lines, show, lock } = data;
        getReferenceLinesState(id).setReferenceLines(lines);
        if (!isUndefined(show)) {
            getReferenceLinesState(id).setShowReferenceLines(show);
        }
        if (!isUndefined(lock)) {
            getReferenceLinesState(id).setLockReferenceLines(lock);
        }
    }
}
